const RolesModule = {
    namespaced: true,
    state: {
        refreshKey: null
    },
    actions: {
        REFRESH({ state, commit }, refreshKey) {
            commit('SetRefreshRoleList', refreshKey);
        },
    },
    mutations: {
        SetRefreshRoleList: function (state, refreshKey) {
            state.refreshKey = refreshKey;
        }
    },
    getters: {
        GetRefreshRoleList: function (state) {
            try {
                return state.refreshKey;
            } catch (err) {
                return null;
            }
        },
    },
};
export default RolesModule;